import { createListFilters } from '../../../../../components'

export type CargosClienteFilters = {
  /** Nome do cargo (busca parcial). */
  nome: string
}

export const { ListFiltersProvider, useListFilters } = createListFilters<CargosClienteFilters>({
  nome: '',
})
